import axios from 'axios'
import { host } from '../../configuraciones'
import { v4 as uuidv4 } from 'uuid';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment'
const fechaHoy = moment().format('YYYY-MM-DD')
//constantes
const dataInicial = {
    activo: false,
    data: {},
    fc_09: {
        entregahologramas: false,
        emicioncertificadonomexportacion: true,
        emicioncertificadopromocion: false,
        inspeccionenvasadoparaexportaci: true,
        fechavisitapropuesta: '',
        maquilador: false,
        propia: false,
        numerosocio: '',
        resposableinstalaciones: '',
        correoelectronico: '',
        telefono: '',
        domicilioproducto: '',
        nombreimportador: '',
        domicilioimportador: '',
        paisdestino: '',
        idaduanasalida: '0',
        observaciones: '',
        tipoinstalacion: ''
    },
    loading: false,
    productos: {},
    fc_09Map: {},
    productosMap: [],
    paginaActiva: 1,
    modoEdicionBorrador: false,
    modoCorreccion: false,
    instalacionesCliente: [],
    marcasCliente: [],
    cliente: [],
    contadorDeFechaFolio: 0,
    files: [],
    filesProductos: [],
    filesMap: [],
    filesProductosMap: [],
    dataDocumentacion: {},
    dataLogin: [],
    relacionesCliente: [],
    instalacionesRelacionadas: [],
    observacionesStatus: []
}

//types
const OBTENER_FC_09_DETALLE_EXITO = 'OBTENER_FC_09_DETALLE_EXITO'
const OBTENER_FC_09_MAP_EXITO = 'OBTENER_FC_09_MAP_EXITO'
const AGREGAR_FC_09_EXITO = 'AGREGAR_FC_09_EXITO'
const AGREGAR_PRODUCTO_FC_09_EXITO = 'AGREGAR_FC_09_PRODUCTO_EXITO'
const AGREGAR_FC_09_BORRADOR_EXITO = 'AGREGAR_FC_09_BORRADOR_EXITO'
const ACTUALIZAR_FC_09_ESTATUS_EXITO = 'ACTUALIZAR_FC_09_ESTATUS_EXITO'
const ELIMINAR_FC_09_SOLICITUD_EXITO_BD = 'ELIMINAR_FC_09_SOLICITUD_EXITO_BD'
const ELIMINAR_FC_09_ANEXOPRODUCTO_EXITO_BD = 'ELIMINAR_FC_09_ANEXOPRODUCTO_EXITO_BD'
const OBTENER_CLIENTE_POR_LOGIN_EXITO = 'OBTENER_CLIENTE_POR_LOGIN_EXITO'
const OBTENER_INSTALACIONES_CLIENTE_EXITO = 'OBTENER_INSTALACIONES_CLIENTE_EXITO'
const OBTENER_FC_09_CONTADOR_FECHA_FOLIO_EXITO = 'OBTENER_FC_09_CONTADOR_FECHA_FOLIO_EXITO'
const ENVIAR_FC_09_BORRADOR_EXITO = 'ENVIAR_FC_09_BORRADOR_EXITO'
const ACTUALIZAR_FC_09_SOLICITUD = 'ACTUALIZAR_FC_09_SOLICITUD'
const ACTUALIZAR_ARCHIVO_FC_09_EXITO = 'ACTUALIZAR_ARCHIVO_FC_09_EXITO'
const AGREGAR_ARCHIVO_FC_09_EXITO = 'AGREGAR_ARCHIVO_FC_09_EXITO'
const OBTENER_FC_09_DETALLE_PARA_DOCUMENTACION_EXITO = 'OBTENER_FC_09_DETALLE_PARA_DOCUMENTACION_EXITO'
const OBTENER_INSTALACIONES_RELACIONADAS_EXITO = 'OBTENER_INSTALACIONES_RELACIONADAS_EXITO'
const AGREGAR_FC_09_FECHA_EXITO = 'AGREGAR_FC_09_FECHA_EXITO'
export const agregarFC_09Accion = createAsyncThunk(
    AGREGAR_FC_09_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const productos = data.productos
            const files = data.files
            const filesProductos = data.filesProductos

            const agregarFC_09 = host + 'FC_09/agregarNuevoFC_09SolicitudCertificado'
            const urlAnexoProductos = host + 'FC_09/agregarFormatoFC09_AnexoProducto'

            const res = await axios.post(agregarFC_09, solicitud)

            let idfc09_solicitudcertificado = res.data.data.idfc09_solicitudcertificado
            // for (let i in files) {
            //     let formData = new FormData();
            //     formData.append(1, files[i].file)
            //     formData.append('nameId', files[i].id)
            //     formData.append('idSolicitud', res.data.data.idfc09_solicitudcertificado)
            //     const resFile = await axios.post(host + 'FC_09/agregarNuevoFC_09AnexosArchivos', formData, {
            //         headers: {
            //             'Content-Type': 'multipart/form-data'
            //         }
            //     })
            // }
            for (let i in productos) {
                const { id, ...anexo } = productos[i]
                anexo.idfc09_solicitudcertificado = idfc09_solicitudcertificado
                const result = await axios.post(urlAnexoProductos, { data: anexo })
                const idfc09_anexoproducto = result.data.data.idfc09_anexoproducto

            }
            return true
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_09Solicitud = createAsyncThunk(
    ACTUALIZAR_FC_09_SOLICITUD,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const productos = { data: data.productos }
            const filesGenerales = data.files
            const filesProductos = data.filesProductos
            const actualizarFC_09 = host + `FC_09/actualizarFC_09SolicitudCertificado`
            const urlAgregarAnexoProductos = host + 'FC_09/agregarFormatoFC09_AnexoProducto'
            const urlActualizarAnexoProductos = host + 'FC_09/actualizarFormatoFC09_AnexoProducto'
            // const urlEliminarAnexoProductos = host + 'FC_09/eliminarFormatoFC09_AnexoProducto/' 

            const res = await axios.put(actualizarFC_09, solicitud)
            let idfc09_solicitudcertificado = res.data.data.idfc09_solicitudcertificado
            /*Acciones para anexo productos*/
            for (let i in productos.data) {
                if (productos.data[i].idfc09_anexoproducto) {
                    const { fc_09archivoproducto, id, ...anexo } = productos.data[i]
                    const resAnexo = await axios.put(urlActualizarAnexoProductos, { data: anexo })

                    // for (const j in filesProductos) {
                    //     if(filesProductos[j].idAnexoBD === undefined){
                    //         if(filesProductos[j].idAnexo === id){
                    //             filesProductos[j].idAnexoFK = productos.data[i].idfc09_anexoproducto
                    //             await agregarFile(filesProductos[j], 'FC_09/agregarNuevoFC_09AnexosArchivosProducto')
                    //         }
                    //     }
                    // }
                }
            }
            // for (const i in filesGenerales) {
            //     if(filesGenerales[i].file.type){
            //         filesGenerales[i].idAnexoFK = solicitud.data.idfc09_solicitudcertificado
            //         if(filesGenerales[i].idAnexo !== undefined) {
            //             await actualizarFile(filesGenerales[i], 'FC_09/actualizarFormatoFC09_AnexosArchivos')
            //         }
            //         else {
            //             await agregarFile(filesGenerales[i], 'FC_09/agregarNuevoFC_09AnexosArchivos')
            //         }
            //     }
            // }
            // for (const i in filesProductos) {
            //     if(filesProductos[i].file.type  && filesProductos[i].idAnexoBD !== undefined){
            //         await actualizarFile(filesProductos[i], 'FC_09/actualizarFormatoFC09_AnexosArchivosProducto')
            //     }
            // }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
const actualizarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexo)
    formData.append('idSolicitudFK', data.idAnexoFK)
    // formData.append('idfc_09archivos', data.idAnexoBD)
    const resFile = await axios.put(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}
const agregarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexoFK)
    const resFile = await axios.post(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}

export const agregarFileFC_09 = createAsyncThunk(
    AGREGAR_ARCHIVO_FC_09_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await agregarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const actualizarFileFC_09 = createAsyncThunk(
    ACTUALIZAR_ARCHIVO_FC_09_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await actualizarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
export const ObtenerClientePorLogin = createAsyncThunk(
    OBTENER_CLIENTE_POR_LOGIN_EXITO,
    async (params) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerClientePorLogin/${params.idlogin}`
            const res = await axios.get(fullUrl)
            // await ObtenerInstalacionesCliente(res.data.data.idcliente)
            let idcliente = res.data.data.idcliente
            let idcartera = res.data.data.idcartera
            const fullUrlInstalaciones = host + `InformacionValida/obtenerAnexosCliente/${idcliente}`
            const fullUrlDatosLogin = host + `AnexoUsuario/obtenerDatosLoginPorCartera/${idcartera}`
            const fullUrlRelaciones = host + `AtencionAClientes/obtenerRelacionesPorIdCliente/${idcliente}`

            const resinstalaciones = await axios.get(fullUrlInstalaciones)
            const resRelaciones = await axios.get(fullUrlRelaciones)

            let datos = []
            let marcas = []
            let instalaciones = []
            instalaciones.push(resinstalaciones.data.data)
            for (const marca of res.data.data.marcascliente) {
                if (marca.isbaja == false) {
                    marcas.push(marca)
               }

            }
            /*for (const marca of res.data.data.marcasproductoconmezcalcliente) {
                if (marca.isbaja == false) {
                    marcas.push(marca)
                }
            }*/
            const resdatoslogin = await axios.get(fullUrlDatosLogin)
            let datosLogin = []
            datosLogin.push(resdatoslogin.data.data)
            datos.push(res.data.data, marcas, instalaciones, datosLogin, resRelaciones.data.data)
            return datos
        } catch (error) {
            console.log(error);
        }
    }
)
export const ObtenerInstalacionesCliente = createAsyncThunk(
    OBTENER_INSTALACIONES_CLIENTE_EXITO,
    async (params) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerAnexosCliente/${params.idcliente}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerContadorDeFechaFolio = createAsyncThunk(
    OBTENER_FC_09_CONTADOR_FECHA_FOLIO_EXITO,
    async (year) => {
        try {
            const fullUrl = host + `Estatus/ContadorGeneralDeFechasFolio/year=${year}`
            const res = await axios.get(fullUrl)
            const contador =
                res.data.data.resultfc_01[0].count + res.data.data.resultfc_05[0].count + res.data.data.resultfc_06[0].count +
                res.data.data.resultfc_08[0].count + res.data.data.resultfc_09[0].count + res.data.data.resultfc_30[0].count +
                res.data.data.resultfc_31[0].count + res.data.data.resultfc_33[0].count + res.data.data.resultfc_34[0].count +
                res.data.data.resultfc_35[0].count + res.data.data.resultfc_36[0].count + res.data.data.resultfc_40[0].count +
                res.data.data.resultfc_41[0].count
            return contador
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_09SolicitudBorrador = createAsyncThunk(
    AGREGAR_FC_09_BORRADOR_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            // const productosAGuardar = {data: data.productosAGuardar}
            const productos = { data: data.productos }
            // const productosAEliminar = data.productosAEliminar

            const actualizarFC_09 = host + `FC_09/actualizarFC_09SolicitudCertificado`
            const urlAgregarAnexoProductos = host + 'FC_09/agregarFormatoFC09_AnexoProducto'
            const urlActualizarAnexoProductos = host + 'FC_09/actualizarFormatoFC09_AnexoProducto'
            // const urlEliminarAnexoProductos = host + 'FC_09/eliminarFormatoFC09_AnexoProducto/' 

            const res = await axios.put(actualizarFC_09, solicitud)
            let idfc09_solicitudcertificado = res.data.data.idfc09_solicitudcertificado
            /*Acciones para anexo productos*/
            for (let i in productos.data) {
                if (productos.data[i].idfc09_anexoproducto) {
                    const { fc_09archivoproducto, id, ...anexo } = productos.data[i]
                    const resAnexo = await axios.put(urlActualizarAnexoProductos, { data: anexo })
                } else {
                    const { id, ...anexoProducto } = productos.data[i]
                    anexoProducto.idfc09_solicitudcertificado = idfc09_solicitudcertificado
                    await axios.post(urlAgregarAnexoProductos, { data: anexoProducto })
                }
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const enviarBorradorFC_09 = createAsyncThunk(
    ENVIAR_FC_09_BORRADOR_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const productos = { data: data.productos }
            const files = data.files
            const filesProductos = data.filesProductos


            const actualizarFC_09 = host + `FC_09/actualizarFC_09SolicitudCertificado`
            const urlAgregarAnexoProductos = host + 'FC_09/agregarFormatoFC09_AnexoProducto'
            const urlActualizarAnexoProductos = host + 'FC_09/actualizarFormatoFC09_AnexoProducto'
            // const urlEliminarAnexoProductos = host + 'FC_09/eliminarFormatoFC09_AnexoProducto/' 

            const res = await axios.put(actualizarFC_09, solicitud)
            let idfc09_solicitudcertificado = res.data.data.idfc09_solicitudcertificado

            // for (let i in files) {
            //     let formData = new FormData();
            //     formData.append(1, files[i].file)
            //     formData.append('nameId', files[i].id)
            //     formData.append('idSolicitud', res.data.data.idfc09_solicitudcertificado)
            //     const resFile = await axios.post(host + 'FC_09/agregarNuevoFC_09AnexosArchivos', formData, {
            //         headers: {
            //             'Content-Type': 'multipart/form-data'
            //         }
            //     })
            // }

            /*Acciones para anexo productos*/
            for (let i in productos.data) {
                const { id, fc_09archivoproducto, ...anexo } = productos.data[i]
                let resAnexoId = null
                if (productos.data[i].idfc09_anexoproducto) {
                    const result = await axios.put(urlActualizarAnexoProductos, { data: anexo })
                    resAnexoId = result.data.data.idfc09_anexoproducto
                } else {
                    anexo.idfc09_solicitudcertificado = idfc09_solicitudcertificado
                    const result = await axios.post(urlAgregarAnexoProductos, { data: anexo })
                    resAnexoId = result.data.data.idfc09_anexoproducto
                }

                // for (const j in filesProductos) {
                //     if(filesProductos[j].idAnexo === id){
                //         let formData = new FormData();
                //         formData.append(1, filesProductos[j].file)
                //         formData.append('nameId', filesProductos[j].id)
                //         formData.append('idSolicitud', resAnexoId)
                //         const resFile = await axios.post(host + 'FC_09/agregarNuevoFC_09AnexosArchivosProducto', formData, {
                //             headers: {
                //                 'Content-Type': 'multipart/form-data'
                //             }
                //         })
                //     }
                // }
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)

export const actualizarFC_09Estatus = createAsyncThunk(
    ACTUALIZAR_FC_09_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)














export const agregarProductoFC_09Accion = createAsyncThunk(
    AGREGAR_PRODUCTO_FC_09_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `FC_09/agregarFormatoFC09_AnexoProducto`
            const res = await axios.post(fullUrl, { data })
            return res
        } catch (error) {
            console.log(error)
        }
    }
)

export const agregarFC_09SolicitudBorrador = createAsyncThunk(
    AGREGAR_FC_09_BORRADOR_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const productos = { data: data.productosAGuardar }

            const agregarFC_09 = host + 'FC_09/agregarNuevoFC_09SolicitudCertificado'
            const urlAnexoProductos = host + 'FC_09/agregarFormatoFC09_AnexoProducto'

            const res = await axios.post(agregarFC_09, solicitud)

            let idfc09_solicitudcertificado = res.data.data.idfc09_solicitudcertificado

            for (const anexo of productos.data) {
                const { id, ...anexoProducto } = anexo
                anexoProducto.idfc09_solicitudcertificado = idfc09_solicitudcertificado
                await axios.post(urlAnexoProductos, { data: anexoProducto })
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)

export const obtenerFC_09SolicitudDetalle = createAsyncThunk(
    OBTENER_FC_09_DETALLE_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_09/obtenerFormatoFC09_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)

            let instalacionesRelacionadasCliente = []
            if (res.data.data.maquilador) {
                const dato = res.data.data.numerosocio + ''
                let numSocio = ''
                if (dato.length === 1) numSocio = '000' + dato
                if (dato.length === 2) numSocio = '00' + dato
                if (dato.length === 3) numSocio = '0' + dato
                if (dato.length === 4) numSocio = '' + dato
                const fullUrlRelacion = host + `InformacionValida/obtenerClientePorNumSocio/${numSocio}`
                const clienteRelacion = await axios.get(fullUrlRelacion)
                const idcliente = clienteRelacion.data.data.idcliente
                const fullUrlInstalaciones = host + `InformacionValida/obtenerInstalacionesRelacionadas/${idcliente}`
                const resinstalaciones = await axios.get(fullUrlInstalaciones)
                instalacionesRelacionadasCliente = resinstalaciones.data.data
            }

            const fc_09_anexoproducto = []
            const documentosProductos = []
            for (let i in res.data.data.fc_09_anexoproducto) {
                res.data.data.fc_09_anexoproducto[i]['id'] = uuidv4()
                for (const j in res.data.data.fc_09_anexoproducto[i].fc_09archivoproducto) {
                    const { ...anexo } = res.data.data.fc_09_anexoproducto[i].fc_09archivoproducto[j]
                    const data = {
                        id: anexo.nameid,
                        file: { name: await getNameFile(anexo.ruta) },
                        idAnexo: anexo.idfc_09archivoproducto,
                        // idAnexoBD: anexo.idfc_09archivoproducto,
                        idAnexoFK: res.data.data.fc_09_anexoproducto[i].idfc09_anexoproducto,
                        estatus: true,
                    }

                    documentosProductos.push(data)
                }
            }
            fc_09_anexoproducto.push({ data: res.data.data.fc_09_anexoproducto })

            const documentosFC_09 = []
            //FILES
            for (const i in res.data.data.fc_09archivos) {
                const { ...anexo } = res.data.data.fc_09archivos[i]
                const data = {
                    id: anexo.nameid,
                    file: { name: await getNameFile(anexo.ruta) },
                    idAnexo: anexo.idfc_09archivos,
                    idAnexoFK: res.data.data.idfc09_solicitudcertificado,
                    estatus: true,
                }

                documentosFC_09.push(data)
            }
            if (res.data.data.fechavisitapropuesta) {
                let fecha = res.data.data.fechavisitapropuesta
                res.data.data.fechavisitapropuesta = moment(fecha).add(1, 'd').format('YYYY-MM-DD')
            }

            return { data: res.data.data, fc_09_anexoproducto, documentosFC_09, documentosProductos, instalacionesRelacionadasCliente }
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerFC_09SolicitudDetalleParaDocumentacion = createAsyncThunk(
    OBTENER_FC_09_DETALLE_PARA_DOCUMENTACION_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_09/obtenerFormatoFC09_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)

            const fc_09_anexoproducto = []
            const documentosProductos = []
            for (let i in res.data.data.fc_09_anexoproducto) {
                res.data.data.fc_09_anexoproducto[i]['id'] = uuidv4()
                for (const j in res.data.data.fc_09_anexoproducto[i].fc_09archivoproducto) {
                    const { ...anexo } = res.data.data.fc_09_anexoproducto[i].fc_09archivoproducto[j]
                    const data = {
                        id: anexo.nameid,
                        file: { name: await getNameFile(anexo.ruta) },
                        idAnexo: anexo.idfc_09archivoproducto,
                        // idAnexoBD: anexo.idfc_09archivoproducto,
                        idAnexoFK: res.data.data.fc_09_anexoproducto[i].idfc09_anexoproducto,
                        estatus: true,
                    }

                    documentosProductos.push(data)
                }
            }
            fc_09_anexoproducto.push({ data: res.data.data.fc_09_anexoproducto })

            const documentosFC_09 = []
            //FILES
            for (const i in res.data.data.fc_09archivos) {
                const { ...anexo } = res.data.data.fc_09archivos[i]
                const data = {
                    id: anexo.nameid,
                    file: { name: await getNameFile(anexo.ruta) },
                    idAnexo: anexo.idfc_09archivos,
                    idAnexoFK: res.data.data.idfc09_solicitudcertificado,
                    estatus: true,
                }

                documentosFC_09.push(data)
            }
            if (res.data.data.fechavisitapropuesta) {
                let fecha = res.data.data.fechavisitapropuesta
                res.data.data.fechavisitapropuesta = moment(fecha).add(1, 'd').format('YYYY-MM-DD')
            }

            return { data: res.data.data, fc_09_anexoproducto, documentosFC_09, documentosProductos }
        } catch (error) {
            console.log(error);
        }
    }
)
const getNameFile = async (ruta) => {
    let nameFile = null
    const array = ruta.split("/")
    // const array = ruta.split("\\")//local
    nameFile = array[array.length - 1]
    return nameFile
}

export const obtenerFC_09Map = createAsyncThunk(
    OBTENER_FC_09_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_09_Solicitud/${solicitudId}`
            const res = await axios.get(fullUrl)
            let mapFiles = []
            let productosMap = []
            let filesProductosMap = []
            let observacionesGeneral = 0
            let observacionesImportador = 0
            let observacionesProductos = 0
            let observacionesFilesGenerales = 0
            let observacionesFilesProductos = 0

            const Map = await obtenerProductosMap(solicitudId)
            productosMap.push(Map.anexoProductoMap)
            mapFiles.push(Map.filesGeneralMap)
            filesProductosMap.push(Map.filesProductosMap)
            for (const i in res.data.data) {
                if (res.data.data.nombreimportadorcheck || res.data.data.domicilioimportadorcheck ||
                    res.data.data.paisdestinocheck || res.data.data.idaduanasalidacheck ||
                    res.data.data.observacionescheck) observacionesImportador++
                else if (res.data.data[i] === true) observacionesGeneral++
            }
            for (const i in productosMap[0]) {
                if (productosMap?.[0]?.[i]?.productocheck === true) observacionesProductos++
            }
            for (const i in mapFiles[0]) {
                if (mapFiles?.[0]?.[i]?.estatuscheck === true) observacionesFilesGenerales++
            }
            for (const i in filesProductosMap[0]) {
                if (filesProductosMap?.[0]?.[i]?.estatuscheck === true) observacionesFilesProductos++
            }
            let observacionesStatus = { observacionesGeneral: observacionesGeneral, observacionesImportador: observacionesImportador, observacionesProductos: observacionesProductos, observacionesFilesGenerales: observacionesFilesGenerales, observacionesFilesProductos: observacionesFilesProductos }
            const solicitudMap = {
                data: res.data.data,
                mapFiles: mapFiles,
                productosMap: productosMap,
                filesProductosMap: filesProductosMap,
                observacionesStatus: observacionesStatus
            }
            return solicitudMap
        } catch (error) {
            console.log(error)
        }
    }
)

const obtenerProductosMap = async (idSolicitud) => {
    try {
        const fullUrl = host + `FC_09/obtenerFormatoFC09_ConDetalle/${idSolicitud}`
        const obtenerProductoMap = host + `MapSolicitud/obtenerMapFC_09_AnexoProducto/`
        const obtenerArchivosGeneralMap = host + `MapSolicitud/obtenerMapFC_09_ArchivosGenerales/`
        const obtenerArchivoProductoMap = host + `MapSolicitud/obtenerMapFC_09_ArchivosProductos/`
        const res = await axios.get(fullUrl)
        const filesGeneral = res.data.data.fc_09archivos
        const filesProductos = res.data.data.fc_09_anexoproducto
        const filesGeneralMap = []
        for (const i in filesGeneral) {
            const resfiles = await axios.get(obtenerArchivosGeneralMap + filesGeneral[i].idfc_09archivos)
            if (resfiles.data.data) {
                resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_09archivos
                resfiles.data.data.nameid = ""
                filesGeneralMap.push(resfiles.data.data)
            }
        }

        const filesProductosMap = []
        for (const producto of filesProductos) {
            for (const archivo of producto.fc_09archivoproducto) {
                const resfiles = await axios.get(obtenerArchivoProductoMap + archivo.idfc_09archivoproducto)
                if (resfiles.data.data) {
                    resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_09archivoproducto
                    filesProductosMap.push(resfiles.data.data)
                }
            }
        }
        // const filesProductos = res.data.data
        let anexoProductoMap = []
        for (const anexo of res.data.data.fc_09_anexoproducto) {
            const resMap = await axios.get(obtenerProductoMap + anexo.idfc09_anexoproducto)
            anexoProductoMap.push(resMap.data.data)

        }
        let Map = { anexoProductoMap: anexoProductoMap, filesGeneralMap: filesGeneralMap, filesProductosMap: filesProductosMap }
        return Map
    } catch (error) {
        console.log(error);
    }
}

export const eliminarFC_09SolicitudBD = createAsyncThunk(
    ELIMINAR_FC_09_SOLICITUD_EXITO_BD,
    async (id) => {
        try {
            const fullUrlSolicitud = host + `FC_09/eliminarFormatoFC09/${id}`
            const resultDelete = await axios.delete(fullUrlSolicitud)
            return resultDelete
        } catch (error) {
            console.log(error);
        }
    }
)

export const eliminarFC_09AnexoProductoBD = createAsyncThunk(
    ELIMINAR_FC_09_ANEXOPRODUCTO_EXITO_BD,
    async (id) => {
        try {
            const fullUrl = host + `FC_09/eliminarFormatoFC09_AnexoProducto/${id}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
export const ObtenerInstalacionesRelacionadas = createAsyncThunk(
    OBTENER_INSTALACIONES_RELACIONADAS_EXITO,
    async (numerosocio) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerClientePorNumSocio/${numerosocio}`
            const res = await axios.get(fullUrl)
            let idcliente = res.data.data.idcliente
            const fullUrlInstalaciones = host + `InformacionValida/obtenerInstalacionesRelacionadas/${idcliente}`
            const resinstalaciones = await axios.get(fullUrlInstalaciones)
            return resinstalaciones.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const actualizarFC_09Fecha = createAsyncThunk(
    AGREGAR_FC_09_FECHA_EXITO,
    async (data) => {
        try {
            const actualizarFC_09 = host + `FC_09/actualizarFC_09SolicitudCertificado`

            const res = await axios.put(actualizarFC_09, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)





export const fc09 = createSlice({
    name: 'fc09Slice',
    initialState: dataInicial,
    reducers: {
        setCambiosFC_09SolicitudBorrador(state, { payload }) {
            state.data = payload
        },
        setCambiosFC_09SolicitudNueva(state, { payload }) {
            state.fc_09 = payload
        },
        actualizarFC_09PaginaActiva(state, { payload }) {
            state.paginaActiva = payload
        },
        actualizarModoBorradorFC_09(state, { payload }) {
            state.modoEdicionBorrador = payload
        },
        actualizarModoCorrecionFC_09(state, { payload }) {
            state.modoCorreccion = payload
        },
        editarFC_09AnexoProducto(state, { payload }) {
            const inputProducto = state.productos.data.filter(field => field.id === payload.id)
            if (inputProducto.length > 0) {
                inputProducto[0][payload.campo] = payload.valor
            }
        },
        agregarFC_09AnexoProducto(state, { payload }) {
            state.productos.data.push(payload)
        },
        agregarFC_09AnexoProductos(state, { payload }) {
            state.productos = payload
        },
        resetDataFC_09(state, { payload }) {
            return dataInicial
        }
    },
    extraReducers: {
        [agregarProductoFC_09Accion.fulfilled]: (state, { payload }) => {
        },
        [agregarFC_09SolicitudBorrador.fulfilled]: (state, { payload }) => {
        },
        [obtenerFC_09SolicitudDetalle.fulfilled]: (state, { payload }) => {
            state.data = payload.data
            state.fc_09 = payload.data
            state.dataDocumentacion = payload.data
            state.productos = { data: payload.data.fc_09_anexoproducto }
            state.files = { data: payload.documentosFC_09 }
            state.filesProductos = { data: payload.documentosProductos }
            state.instalacionesRelacionadas = payload.instalacionesRelacionadasCliente
            // for(let i in payload.data.data.fc_09_anexoproducto) {
            //     payload.data.data.fc_09_anexoproducto[i]['id'] = uuidv4()  
            // }
            // state.productos = {data: payload.data.data.fc_09_anexoproducto}
        },
        [obtenerFC_09Map.fulfilled]: (state, { payload }) => {
            state.fc_09Map = payload.data
            state.productosMap = payload.productosMap[0]
            state.filesMap = payload.mapFiles[0]
            state.filesProductosMap = payload.filesProductosMap[0]
            state.observacionesStatus = payload.observacionesStatus
        },
        [eliminarFC_09SolicitudBD.fulfilled]: (state, { payload }) => {
        },
        [eliminarFC_09AnexoProductoBD.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_09Estatus.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_09SolicitudBorrador.fulfilled]: (state, { payload }) => {
        },
        [agregarFC_09Accion.fulfilled]: (state, { payload }) => {
        },
        [ObtenerInstalacionesCliente.fulfilled]: (state, { payload }) => {
            state.instalacionesCliente = payload
        },
        [ObtenerClientePorLogin.fulfilled]: (state, { payload }) => {
            state.cliente = payload[0]
            state.marcasCliente = payload[1]
            state.instalacionesCliente = payload[2][0]
            state.dataLogin = payload[3][0][0]
            state.relacionesCliente = payload[4]
        },
        [obtenerContadorDeFechaFolio.fulfilled]: (state, { payload }) => {
            state.contadorDeFechaFolio = payload
        },
        [enviarBorradorFC_09.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_09Solicitud.fulfilled]: (state, { payload }) => {
        },
        [agregarFileFC_09.fulfilled]: (state, { payload }) => {
        },
        [actualizarFileFC_09.fulfilled]: (state, { payload }) => {
        },
        [obtenerFC_09SolicitudDetalleParaDocumentacion.fulfilled]: (state, { payload }) => {
            state.dataDocumentacion = payload.data
            state.files = { data: payload.documentosFC_09 }
            state.filesProductos = { data: payload.documentosProductos }
        },
        [ObtenerInstalacionesRelacionadas.fulfilled]: (state, { payload }) => {
            state.instalacionesRelacionadas = payload
        },
    }
})

const agregarArchivoDeProducto = async (fileProducto, idfc09_solicitudcertificado) => {

    try {
        for (let item in fileProducto) {
            if (fileProducto[item]) {
                let formData = new FormData();
                formData.append(Number(1), fileProducto[item])
                formData.append('idSolicitud', idfc09_solicitudcertificado)
                const resFile = await axios.post(host + 'FC_09/agregarNuevoFC_09AnexosArchivos', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
            }
        }
    } catch (error) {
        console.log(error);
    }
}

export const {
    actualizarFC_09PaginaActiva,
    actualizarModoBorradorFC_09,
    actualizarModoCorrecionFC_09,
    agregarFC_09AnexoProductos,
    agregarFC_09AnexoProducto,
    editarFC_09AnexoProducto,
    resetDataFC_09,
    setCambiosFC_09SolicitudBorrador,
    setCambiosFC_09SolicitudNueva } = fc09.actions
export const FC09ReducerBeneficiario = fc09.reducer

// //reducer
// export default function FC_09Reducer(state = dataInicial, action) {
//     switch (action.type) {
//         case AGREGAR_FC_09_EXITO:
//             return { ...state}
//         case AGREGAR_PRODUCTO_FC_09_EXITO:
//             return { ...state}
//         case GUARDAR_CAMBIOS_FC_09_EXITO:
//             {
//                 Object.assign(state.fc_09, action.payload);
//                 return {...state, fc_09: action.payload}
//             }
//         case GUARDAR_CAMBIOS_FC_09_PRODUCTOS_EXITO: 
//             return {...state, productos: action.payload}
//         case ACTUALIZAR_FC_09_PAGINA:
//             return {...state, paginaActiva: action.payload}
//         case OBTENER_FC_09_DETALLE_EXITO:
//             return {...state, data:action.payload}
//         case AGREGAR_FC_09_BORRADOR_EXITO:
//             return {...state}
//         case ELIMINAR_FC_09_SOLICITUD_EXITO_BD:
//             return {...state}
//         case AGREGAR_FC_09_ANEXO_EXITO:
//             {
//                 Object.assign(state.productos, action.payload);
//                 return {...state, productos: action.payload}
//             }
//         case GUARDAR_CAMBIOS_FC_09_BORRADOR_EXITO:
//             {
//                 Object.assign(state.data, action.payload);
//                 return {...state, data: action.payload}
//             }
//         case ACTUALIZAR_MODO_EDICION_FC_09_EXITO:
//             {
//                 Object.assign(state.modoEdicionBorrador, action.payload);
//                 Object.assign(state.modoEdicionBorrador, {modoEdicionBorrador: action.payload})

//                 return {...state, modoEdicionBorrador: action.payload}
//             }
//         case RESET_DATA_EXITO :
//             {
//                 let newDataObject = Object.assign(dataInicial, {
//                     activo: false,
//                     data: {},
//                     fc_09: {},
//                     loading: false,
//                     productos: {},
//                     paginaActiva: 1,
//                     modoEdicionBorrador: false
//                 })
//                 return newDataObject
//             }
//         default:
//             return state
//     }
// }

// //acciones

// /*Funcionalidad de borrador*/